import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import reglas from './assets/js/reglas';

Vue.mixin(reglas);

// Lodash
window._ = require('lodash');
Vue.set(Vue.prototype, '_', _);

window.moment = require('moment');
window.Combinatorics = require('./assets/js/combinatorics.js');

const isLocalHost=window.location.href.includes('localhost') ? true : false;
// const host=isLocalHost ? "http://localhost:8081/wscontigo/public/" : (window.location.href.includes('172.16.1.25') ? "http://172.16.1.25:80/" : "http://190.63.184.46:8084/");
//const host = isLocalHost ? "http://localhost:8081/" : `${window.location.protocol}//${window.location.hostname}:8081/`
const host = "https://api-certification.contigoseguros.com.ec/wscontigo/";
console.log(`host=${host}`);
window.BASE_URI=host
// Servido por el mismo Ingress/dominio que wscontigo, vía el path
// /wscontigo-ws (proxy a los puertos 3000/3001 del socket-server dentro
// del cluster) - sin abrir puertos nuevos, con el mismo certificado TLS.
window.URL_SOCKET = "wss://api-certification.contigoseguros.com.ec/wscontigo-ws";
console.log(`URL_SOCKET=${URL_SOCKET}`);


// Moment
import * as moment from 'moment';
moment.locale('es');

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

// axios
import axios from "./plugins/axios"
window.axios = axios

// Mensajes Estandar
import mensajeEstandar from "./assets/js/mensajesEstandar";
window.mensajeEstandar = mensajeEstandar;


Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  data() {
    return {
      drawer: true,
      isTouch: false,//window.Modernizr.touchevents,
      obUsuario:{},
      accessPla:false,
      // Notificación
      notificacion: {
        mostrarALerta: false,
        mensaje: '',
        color: ''
      },
      // Cargando
      loading: {
        mostrar: false
      },
      notifications:{
        messages:0,
        data:[],
        color:'primary'
      }
    }
  },
  methods: {
    mensajeAlerta(mensaje, tipo) {
      var objeto = {
        E: {
          color: 'error',
          mensaje: mensaje,
          icono: 'error',
          bg: 'black'
        },
        I: {
          color: 'info',
          mensaje: mensaje,
          icono: 'info',
          bg: 'black'
        },
        S: {
          color: 'success',
          mensaje: mensaje,
          icono: 'check ',
          bg: 'black'
        },
        W: {
          color: 'warning',
          mensaje: mensaje,
          icono: 'warning ',
          bg: 'black'
        }
      }

      _.forEach(objeto[tipo], (v, k) => {
        this.$root.notificacion[k] = v;
      });

      this.$root.notificacion.mostrarALerta = true;
    },
    notificacionMensaje(mensaje, tipo) {
      var objeto = {
        E: {
          color: 'white',
          mensaje: mensaje,
          icono: 'error',
          bg: 'error'
        },
        I: {
          color: 'white',
          mensaje: mensaje,
          icono: 'info',
          bg: 'info'
        },
        S: {
          color: 'light-green darken-3',
          mensaje: mensaje,
          icono: 'check ',
          bg: 'success'
        },
        W: {
          color: 'white',
          mensaje: mensaje,
          icono: 'warning ',
          bg: 'amber darken-1'
        }
      }

      _.forEach(objeto[tipo], (v, k) => {
        this.$root.notificacion[k] = v;
      });

      this.$root.notificacion.mostrarALerta = true;
    },
    onCargando(mostrar) {
      this.$root.loading.mostrar = mostrar;
    }
  },
  render: h => h(App)
}).$mount('#app')